/**
 * 轻量级音效工具 - 使用 Web Audio API
 * 不需要加载音频文件，直接生成声音
 * 内存占用极低，适合移动端
 */
import levelCompleteAudioUrl from 'asset/music/guoguan1.MP3';
import feedSound1 from 'asset/music/skill/1.MP3';
import feedSound2 from 'asset/music/skill/2.MP3';
import feedSound3 from 'asset/music/skill/3.MP3';
import feedSound4 from 'asset/music/skill/4.MP3';
import detailSucc0 from 'asset/music/detail/succ0.MP3';
import detailSucc1 from 'asset/music/detail/succ1.MP3';
import detailSucc2 from 'asset/music/detail/succ2.MP3';
// skill_e 挨饿音频按需加载，避免一次性加载 13 个

// 每日打卡：打卡随机 1/2/3，补签 0
import qiandao0 from 'asset/daka/qiandao/0.mp3';
import qiandao1 from 'asset/daka/qiandao/1.mp3';
import qiandao2 from 'asset/daka/qiandao/2.mp3';
import qiandao3 from 'asset/daka/qiandao/3.mp3';
const QIANDAO_SIGN_URLS = [qiandao1, qiandao2, qiandao3];

let checkinAudioEl = null;

/** 打卡时：随机播放 1/2/3.mp3 */
export const playCheckinSignSound = () => {
  try {
    const idx = Math.floor(Math.random() * 3);
    const url = QIANDAO_SIGN_URLS[idx];
    if (!checkinAudioEl) {
      checkinAudioEl = new Audio();
      checkinAudioEl.preload = 'none';
      checkinAudioEl.volume = 0.75;
    }
    checkinAudioEl.src = url;
    checkinAudioEl.currentTime = 0;
    const p = checkinAudioEl.play();
    if (p?.catch) p.catch(() => {});
  } catch (e) {}
};

/** 补签时：播放 0.mp3 */
export const playCheckinMakeupSound = () => {
  try {
    if (!checkinAudioEl) {
      checkinAudioEl = new Audio();
      checkinAudioEl.preload = 'none';
      checkinAudioEl.volume = 0.75;
    }
    checkinAudioEl.src = qiandao0;
    checkinAudioEl.currentTime = 0;
    const p = checkinAudioEl.play();
    if (p?.catch) p.catch(() => {});
  } catch (e) {}
};

// Detail 闯关成功：随机播放 succ0/succ1/succ2
const DETAIL_SUCC_URLS = [detailSucc0, detailSucc1, detailSucc2];

// INITIAL_ITEMS[0]->1.MP3, [1]->4.MP3, [2]->2.MP3, [3]->3.MP3
const FEED_SOUND_URLS = [feedSound1, feedSound2, feedSound3, feedSound4];
const FEED_INDEX_MAP = [0, 3, 1, 2]; // 食物 index -> 音效文件 index

let audioContext = null;
let levelCompleteAudioEl = null;
let feedAudioEl = null;
let detailSuccAudioEl = null;

// 懒加载 AudioContext（节省内存）
const getAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  // iOS 需要在用户交互后 resume
  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }
  return audioContext;
};

// 懒加载本地闯关成功音效，单例复用，避免重复创建
const getLevelCompleteAudio = () => {
  if (!levelCompleteAudioEl) {
    levelCompleteAudioEl = new Audio(levelCompleteAudioUrl);
    levelCompleteAudioEl.preload = 'none'; // 首次播放时才加载，节省内存
    levelCompleteAudioEl.volume = 0.75;
  }
  return levelCompleteAudioEl;
};

/**
 * 播放喂养音效（对应 INITIAL_ITEMS 的 1/2/3/4）
 * index 0-3，多食物时取最高；单例 Audio 复用，节省内存
 * 投喂时先打断挨饿音频
 */
export const playFeedSoundByIndex = (index) => {
  try {
    if (hungryAudioEl) {
      hungryAudioEl.pause();
      hungryAudioEl.currentTime = 0;
      hungryAudioEl.src = '';
    }
    const raw = Math.max(0, Math.min(3, Math.floor(index)));
    const i = FEED_INDEX_MAP[raw];
    if (!feedAudioEl) {
      feedAudioEl = new Audio();
      feedAudioEl.preload = 'none';
      feedAudioEl.volume = 0.75;
    }
    feedAudioEl.src = FEED_SOUND_URLS[i];
    feedAudioEl.currentTime = 0;
    const p = feedAudioEl.play();
    if (p?.catch) p.catch(() => {});
  } catch (e) {}
};

/**
 * 播放成功提示音（叮~）
 * 清脆的上升音调，表示成功
 */
export const playSuccessSound = () => {
  try {
    const ctx = getAudioContext();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    
    // 设置音调（从 C5 到 G5 的上升音）
    oscillator.frequency.setValueAtTime(523, ctx.currentTime); // C5
    oscillator.frequency.setValueAtTime(659, ctx.currentTime + 0.1); // E5
    oscillator.frequency.setValueAtTime(784, ctx.currentTime + 0.2); // G5
    
    // 设置音量包络（淡入淡出）
    gainNode.gain.setValueAtTime(0, ctx.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.3, ctx.currentTime + 0.05);
    gainNode.gain.linearRampToValueAtTime(0.2, ctx.currentTime + 0.2);
    gainNode.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.4);
    
    oscillator.type = 'sine'; // 正弦波，声音柔和
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.4);
  } catch (e) {
    // 静默失败，不影响游戏
  }
};

/**
 * 终止 Detail 闯关成功音效（抽奖、下一关等行为前调用，避免多音效重叠）
 */
export const stopDetailSuccSound = () => {
  try {
    if (detailSuccAudioEl) {
      detailSuccAudioEl.pause();
      detailSuccAudioEl.currentTime = 0;
      detailSuccAudioEl.src = '';
    }
  } catch (e) {}
};

/**
 * Detail 页闯关成功音效（随机播放 succ0/1/2）
 */
export const playLevelCompleteSoundByStars = () => {
  try {
    const i = Math.floor(Math.random() * 3);
    if (!detailSuccAudioEl) {
      detailSuccAudioEl = new Audio();
      detailSuccAudioEl.preload = 'none';
      detailSuccAudioEl.volume = 0.75;
    }
    detailSuccAudioEl.src = DETAIL_SUCC_URLS[i];
    detailSuccAudioEl.currentTime = 0;
    const p = detailSuccAudioEl.play();
    if (p?.catch) p.catch(() => {});
  } catch (e) {}
};

/**
 * Detail 页原先的 JS 模拟闯关成功音效（四音上行，Web Audio）
 * 与 playLevelCompleteSoundByStars 同时播放时使用，不占用额外音频文件
 */
export const playLevelCompleteSoundSynthetic = () => {
  try {
    const ctx = getAudioContext();
    const notes = [523, 659, 784, 1047];
    const duration = 0.15;
    notes.forEach((freq, i) => {
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      oscillator.frequency.value = freq;
      oscillator.type = 'sine';
      const startTime = ctx.currentTime + i * duration;
      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.25, startTime + 0.03);
      gainNode.gain.linearRampToValueAtTime(0, startTime + duration);
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    });
  } catch (e) {
    // 静默失败
  }
};

/**
 * 播放闯关成功音效（签到等用 guoguan1.MP3）
 * 三连音上升，表示关卡完成
 */
export const playLevelCompleteSound = () => {
  try {
    const audio = getLevelCompleteAudio();
    // 若正在播放，重新从头播放，确保每次闯关成功都有完整提示音
    if (!audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    } else {
      audio.currentTime = 0;
    }
    const playPromise = audio.play();
    if (playPromise?.catch) {
      playPromise.catch(() => {
        // 播放失败时静默处理，避免报错影响主流程
      });
    }
    // 如需恢复为 Web Audio 版本，可注释掉本段代码并恢复下面的旧逻辑：
    /*
    const ctx = getAudioContext();
    const notes = [523, 659, 784, 1047];
    const duration = 0.15;
    notes.forEach((freq, i) => {
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      oscillator.frequency.value = freq;
      oscillator.type = 'sine';
      const startTime = ctx.currentTime + i * duration;
      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.25, startTime + 0.03);
      gainNode.gain.linearRampToValueAtTime(0, startTime + duration);
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    });
    */
  } catch (e) {
    // 静默失败
  }
};

/**
 * 播放错误提示音（低沉短促，音量加重）
 * 增强版本：确保 AudioContext 已激活，添加重试机制
 */
export const playErrorSound = () => {
  try {
    const ctx = getAudioContext();
    
    // 确保 AudioContext 已激活（iOS 等需要用户交互后才能播放）
    if (ctx.state === 'suspended') {
      ctx.resume().then(() => {
        // Resume 成功后立即播放
        playErrorSoundInternal(ctx);
      }).catch(() => {
        // Resume 失败，直接尝试播放
        playErrorSoundInternal(ctx);
      });
    } else {
      playErrorSoundInternal(ctx);
    }
  } catch (e) {
    // 静默失败，不影响游戏
  }
};

// 内部播放函数
const playErrorSoundInternal = (ctx) => {
  try {
    // 主音 - 低沉下降
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    
    oscillator.frequency.setValueAtTime(350, ctx.currentTime);
    oscillator.frequency.setValueAtTime(180, ctx.currentTime + 0.2);
    
    gainNode.gain.setValueAtTime(0, ctx.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.5, ctx.currentTime + 0.02);
    gainNode.gain.linearRampToValueAtTime(0.3, ctx.currentTime + 0.15);
    gainNode.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.3);
    
    oscillator.type = 'triangle';
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.3);
    
    // 添加一个低频加强
    const bass = ctx.createOscillator();
    const bassGain = ctx.createGain();
    bass.connect(bassGain);
    bassGain.connect(ctx.destination);
    
    bass.frequency.value = 120;
    bass.type = 'sine';
    
    bassGain.gain.setValueAtTime(0, ctx.currentTime);
    bassGain.gain.linearRampToValueAtTime(0.4, ctx.currentTime + 0.03);
    bassGain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.25);
    
    bass.start(ctx.currentTime);
    bass.stop(ctx.currentTime + 0.25);
  } catch (e) {
    // 静默失败
  }
};

/**
 * 播放老虎机滚动音效（滴滴滴）
 */
export const playSlotSpinSound = () => {
  try {
    const ctx = getAudioContext();
    const duration = 0.08;
    
    // 播放连续的滴滴声
    for (let i = 0; i < 3; i++) {
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = 800 + i * 100;
      oscillator.type = 'square';
      
      const startTime = ctx.currentTime + i * 0.1;
      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.1, startTime + 0.01);
      gainNode.gain.linearRampToValueAtTime(0, startTime + duration);
      
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    }
  } catch (e) {
    // 静默失败
  }
};

/**
 * 播放老虎机中奖音效（欢快上升音）
 */
export const playSlotWinSound = () => {
  try {
    const ctx = getAudioContext();
    const notes = [523, 659, 784, 1047, 1319]; // C5-E6 上升
    const duration = 0.12;
    
    notes.forEach((freq, i) => {
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = freq;
      oscillator.type = 'sine';
      
      const startTime = ctx.currentTime + i * 0.1;
      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.2, startTime + 0.02);
      gainNode.gain.linearRampToValueAtTime(0, startTime + duration);
      
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    });
  } catch (e) {
    // 静默失败
  }
};

/**
 * 播放技能使用音效（魔法释放感）
 */
export const playSkillSound = () => {
  try {
    const ctx = getAudioContext();
    
    // 上升的魔法音效
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    
    // 从低到高的滑音
    oscillator.frequency.setValueAtTime(200, ctx.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.15);
    oscillator.frequency.exponentialRampToValueAtTime(1200, ctx.currentTime + 0.25);
    
    oscillator.type = 'sine';
    
    gainNode.gain.setValueAtTime(0, ctx.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.25, ctx.currentTime + 0.05);
    gainNode.gain.linearRampToValueAtTime(0.15, ctx.currentTime + 0.2);
    gainNode.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.35);
    
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.35);
    
    // 添加一个闪烁的高音点缀
    const sparkle = ctx.createOscillator();
    const sparkleGain = ctx.createGain();
    sparkle.connect(sparkleGain);
    sparkleGain.connect(ctx.destination);
    
    sparkle.frequency.value = 1500;
    sparkle.type = 'sine';
    
    sparkleGain.gain.setValueAtTime(0, ctx.currentTime + 0.1);
    sparkleGain.gain.linearRampToValueAtTime(0.15, ctx.currentTime + 0.15);
    sparkleGain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.3);
    
    sparkle.start(ctx.currentTime + 0.1);
    sparkle.stop(ctx.currentTime + 0.3);
  } catch (e) {
    // 静默失败
  }
};

/**
 * 播放宝箱打开音效（欢快、有成就感）
 * 使用Web Audio API，不占用内存
 */
export const playTreasureBoxOpenSound = () => {
  try {
    const ctx = getAudioContext();
    
    // 确保 AudioContext 已激活
    if (ctx.state === 'suspended') {
      ctx.resume().then(() => {
        playTreasureBoxOpenSoundInternal(ctx);
      }).catch(() => {
        playTreasureBoxOpenSoundInternal(ctx);
      });
    } else {
      playTreasureBoxOpenSoundInternal(ctx);
    }
  } catch (e) {
    // 静默失败
  }
};

// 内部播放函数
const playTreasureBoxOpenSoundInternal = (ctx) => {
  try {
    // 主旋律：上升的欢快音调（C5 -> E5 -> G5 -> C6）
    const mainNotes = [523, 659, 784, 1047]; // C5, E5, G5, C6
    const noteDuration = 0.15;
    
    mainNotes.forEach((freq, i) => {
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = freq;
      oscillator.type = 'sine';
      
      const startTime = ctx.currentTime + i * noteDuration;
      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.3, startTime + 0.03);
      gainNode.gain.linearRampToValueAtTime(0, startTime + noteDuration);
      
      oscillator.start(startTime);
      oscillator.stop(startTime + noteDuration);
    });
    
    // 添加低音加强（营造开启感）
    const bass = ctx.createOscillator();
    const bassGain = ctx.createGain();
    bass.connect(bassGain);
    bassGain.connect(ctx.destination);
    
    bass.frequency.setValueAtTime(200, ctx.currentTime);
    bass.frequency.exponentialRampToValueAtTime(100, ctx.currentTime + 0.3);
    bass.type = 'sine';
    
    bassGain.gain.setValueAtTime(0, ctx.currentTime);
    bassGain.gain.linearRampToValueAtTime(0.4, ctx.currentTime + 0.05);
    bassGain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.3);
    
    bass.start(ctx.currentTime);
    bass.stop(ctx.currentTime + 0.3);
    
    // 添加高音点缀（闪烁感）
    const sparkle = ctx.createOscillator();
    const sparkleGain = ctx.createGain();
    sparkle.connect(sparkleGain);
    sparkleGain.connect(ctx.destination);
    
    sparkle.frequency.value = 1500;
    sparkle.type = 'sine';
    
    sparkleGain.gain.setValueAtTime(0, ctx.currentTime + 0.2);
    sparkleGain.gain.linearRampToValueAtTime(0.2, ctx.currentTime + 0.25);
    sparkleGain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.4);
    
    sparkle.start(ctx.currentTime + 0.2);
    sparkle.stop(ctx.currentTime + 0.4);
  } catch (e) {
    // 静默失败
  }
};

let hungryAudioEl = null;

/**
 * Pet 页首次用户交互时调用（保留兼容，HTML5 Audio 一般不需单独解锁）
 */
export const unlockPetAudio = () => {
  try {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
  } catch (e) {}
};

/**
 * 播放悟空挨饿音效（改用 HTML5 Audio，与 Home 页一致，移动端可自动播放）
 * phase 1-6: 随机 skill_e 1-6；phase 7-12: 随机 skill_e 7-13
 */
export const playHungryAudio = (phase) => {
  return new Promise((resolve) => {
    try {
      if (!phase || phase < 1) {
        resolve();
        return;
      }
      let startIdx; let endIdx;
      if (phase <= 6) {
        startIdx = 1; endIdx = 6;
      } else {
        startIdx = 7; endIdx = 13;
      }
      const idx = startIdx + Math.floor(Math.random() * (endIdx - startIdx + 1));
      import(`asset/music/skill/skill_e/${idx}.mp3`)
        .then((m) => {
          const url = m.default;
          if (!url) {
            resolve();
            return;
          }
          if (!hungryAudioEl) {
            hungryAudioEl = new Audio();
            hungryAudioEl.preload = 'none';
            hungryAudioEl.volume = 0.75;
          }
          hungryAudioEl.src = url;
          hungryAudioEl.currentTime = 0;
          hungryAudioEl.onended = () => resolve();
          hungryAudioEl.onerror = () => resolve();
          const p = hungryAudioEl.play();
          if (p?.catch) p.catch(() => resolve());
        })
        .catch(() => resolve());
    } catch (e) {
      resolve();
    }
  });
};

/**
 * 离开 Pet 页时停止投喂、挨饿等音频
 */
export const stopPetAudio = () => {
  try {
    if (feedAudioEl) {
      feedAudioEl.pause();
      feedAudioEl.currentTime = 0;
      feedAudioEl.src = '';
    }
    if (hungryAudioEl) {
      hungryAudioEl.pause();
      hungryAudioEl.currentTime = 0;
      hungryAudioEl.src = '';
    }
  } catch (e) {}
};

/**
 * 清理资源（页面卸载时调用）
 */
export const cleanupAudio = () => {
  if (audioContext) {
    audioContext.close();
    audioContext = null;
  }
  if (levelCompleteAudioEl) {
    levelCompleteAudioEl.pause();
    levelCompleteAudioEl = null;
  }
  if (feedAudioEl) {
    feedAudioEl.pause();
    feedAudioEl.src = '';
    feedAudioEl = null;
  }
  if (detailSuccAudioEl) {
    detailSuccAudioEl.pause();
    detailSuccAudioEl.src = '';
    detailSuccAudioEl = null;
  }
  stopPetAudio();
};

// ---------- App 后台/前台：HTML5 Audio 与 Web AudioContext ----------
let resumeHungry = false;
let resumeFeed = false;
let resumeCheckin = false;
let resumeDetailSucc = false;
let resumeLevelComplete = false;

/**
 * 进入后台：暂停 Pet 挨饿/投喂等 HTML5 音频，并 suspend AudioContext（不销毁实例）
 */
export function handleAppAudioBackgroundSfx() {
  try {
    resumeHungry = !!(hungryAudioEl && !hungryAudioEl.paused);
    resumeFeed = !!(feedAudioEl && !feedAudioEl.paused);
    resumeCheckin = !!(checkinAudioEl && !checkinAudioEl.paused);
    resumeDetailSucc = !!(detailSuccAudioEl && !detailSuccAudioEl.paused);
    resumeLevelComplete = !!(levelCompleteAudioEl && !levelCompleteAudioEl.paused);

    if (hungryAudioEl) hungryAudioEl.pause();
    if (feedAudioEl) feedAudioEl.pause();
    if (checkinAudioEl) checkinAudioEl.pause();
    if (detailSuccAudioEl) detailSuccAudioEl.pause();
    if (levelCompleteAudioEl) levelCompleteAudioEl.pause();
    if (audioContext && audioContext.state === 'running') {
      audioContext.suspend().catch(() => {});
    }
  } catch (e) {}
}

/**
 * 回到前台：仅恢复进入后台时正在播放的轨道
 */
export function handleAppAudioForegroundSfx() {
  try {
    if (resumeHungry && hungryAudioEl) hungryAudioEl.play().catch(() => {});
    if (resumeFeed && feedAudioEl) feedAudioEl.play().catch(() => {});
    if (resumeCheckin && checkinAudioEl) checkinAudioEl.play().catch(() => {});
    if (resumeDetailSucc && detailSuccAudioEl) detailSuccAudioEl.play().catch(() => {});
    if (resumeLevelComplete && levelCompleteAudioEl) levelCompleteAudioEl.play().catch(() => {});
    resumeHungry = false;
    resumeFeed = false;
    resumeCheckin = false;
    resumeDetailSucc = false;
    resumeLevelComplete = false;
    if (audioContext && audioContext.state === 'suspended') {
      audioContext.resume().catch(() => {});
    }
  } catch (e) {}
}

